import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../Forms/Element/CustomSelect';
import axiosInstance from '../../../../services/AxiosInstance';
import Api from '../../../../constants/Api';

const PerformancePlanSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);

  useEffect(() => {
    axiosInstance.get(Api.performance.plan)
      .then(response => {
        const options = response.data.map(item => ({
          value: item.id,
          label: item.name
        }));
        setEntities(options);
      });
  }, []);

  return (
    <CustomSelect options={entities} value={props.value} onChange={props.onChange} isClearable placeholder={t("select")} isDisabled={props.isDisabled} />
  );
}

export default PerformancePlanSelect;
